import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { Box, Button, Divider } from "@mui/material";
import { Link } from "react-router-dom";

function BaseList() {
  return (
    <>
      <Navbar />
      <main>
        <section className="h-[250px] m-auto pt-[64px] branch-title">
          <div className="text-center mb-[44px]"></div>
        </section>
        <section className="max-w-[1300px] m-auto pt-[10px] mb-16 md-l:w-auto">
          <Box className="my-[10px]" display="flex" width="100%">
            <Box className="pl-[50px] pr-[30px] pt-[20px] pb-[20px]" width="50%">
              <img src="./branch-1-title.jpg" alt="" className="border-8 border-white shadow-2xl" />
            </Box>
            <Box className="pl-[30px] pr-[50px] pt-[30px] pb-[30px]" width="50%">
              <p
                className="pb-[15px]"
                style={{ fontSize: "30px", color: "#A93230", fontWeight: 400 }}
              >
                台中總公司
              </p>
              <p
                className="pb-[10px]"
                style={{ fontSize: "20px", color: "#696969", fontWeight: 400 }}
              >
                電話：(04)2202-8800
              </p>
              <p
                className="pb-[25px]"
                style={{ fontSize: "20px", color: "#696969", fontWeight: 400 }}
              >
                住址：台中市北區中清路一段79號10樓（附有充電樁）
              </p>
              <Button
                sx={{
                  fontSize: "20px",
                  padding: "13px 35px",
                  backgroundColor: "#FFCC06",
                  color: "black",
                  fontWeight: 400,
                  "&:hover": { backgroundColor: "darkorange" },
                }}
                component={Link}
                to="/branch1"
              >
                查看更多
              </Button>
            </Box>
          </Box>
          <Divider />
          <Box className="my-[10px]" display="flex" width="100%">
            <Box className="pl-[50px] pr-[30px] pt-[20px] pb-[20px]" width="50%">
              <img src="./branch-2-title.jpg" alt="" className="border-8 border-white shadow-2xl" />
            </Box>
            <Box className="pl-[30px] pr-[50px] pt-[30px] pb-[30px]" width="50%">
              <p
                className="pb-[15px]"
                style={{ fontSize: "30px", color: "#A93230", fontWeight: 400 }}
              >
                台北分公司
              </p>
              <p
                className="pb-[10px]"
                style={{ fontSize: "20px", color: "#696969", fontWeight: 400 }}
              >
                電話：(02)2767-9911
              </p>
              <p
                className="pb-[25px]"
                style={{ fontSize: "20px", color: "#696969", fontWeight: 400 }}
              >
                住址：台北市松山區南京東路五段343號5樓（南京IC大樓）
              </p>
              <Button
                sx={{
                  fontSize: "20px",
                  padding: "13px 35px",
                  backgroundColor: "#FFCC06",
                  color: "black",
                  fontWeight: 400,
                  "&:hover": { backgroundColor: "darkorange" },
                }}
              >
                查看更多
              </Button>
            </Box>
          </Box>
          <Divider />
          <Box className="my-[10px]" display="flex" width="100%">
            <Box className="pl-[50px] pr-[30px] pt-[20px] pb-[20px]" width="50%">
              <img src="./branch-3-title.jpg" alt="" className="border-8 border-white shadow-2xl" />
            </Box>
            <Box className="pl-[30px] pr-[50px] pt-[30px] pb-[30px]" width="50%">
              <p
                className="pb-[25px]"
                style={{ fontSize: "30px", color: "#A93230", fontWeight: 400 }}
              >
                高雄分公司
              </p>
              <p
                className="pb-[10px]"
                style={{ fontSize: "20px", color: "#696969", fontWeight: 400 }}
              >
                電話：(07)3816-999
              </p>
              <p
                className="pb-[25px]"
                style={{ fontSize: "20px", color: "#696969", fontWeight: 400 }}
              >
                住址：高雄市三民區陽明路381號4樓（京城圓山廈）
              </p>
              <Button
                sx={{
                  fontSize: "20px",
                  padding: "13px 35px",
                  backgroundColor: "#FFCC06",
                  color: "black",
                  fontWeight: 400,
                  "&:hover": { backgroundColor: "darkorange" },
                }}
              >
                查看更多
              </Button>
            </Box>
          </Box>
          <Divider />
        </section>
      </main>
      <Footer />
    </>
  );
}

export default BaseList;
